// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"791":"ff63a5c3","941":"ff63a5c3"}[chunkId] + ".css";
};